import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { LoadingService } from './service/loading.service';
import { AccountLimitsService } from "./service/account-limits.service";

@Component({
  selector: 'mc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private loadingService: LoadingService,
    private accountLimitsService: AccountLimitsService
  ) { }

  ngOnInit(): void {
    this.accountLimitsService.initAccountLimits();
  }

  isLoading$(): Observable<boolean> {
    return this.loadingService.isLoading$();
  }
}
